import React, { useState, useEffect } from 'react';
import { Navbar as BootstrapNavbar, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.less';

function Navbar() {

    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname;
    const navLinks = [
        { path: '/', label: '首頁介紹' },
        { path: '/search-bus', label: '查詢公車' },
        { path: '/contact-us', label: '聯絡我們' },
    ];

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 1) { 
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <BootstrapNavbar className={`navbar ${isScrolled ? 'scrolled' : ''}`} variant="dark" fixed="top">
        <BootstrapNavbar.Brand as={Link} to="/">找找公車</BootstrapNavbar.Brand>
        <Nav className="mr-auto">
            {navLinks.map(link => (
                <Nav.Link 
                    key={link.path} 
                    as={Link} 
                    to={link.path} 
                    className={currentPath === link.path ? 'active' : ''}
                >
                    {link.label}
                </Nav.Link>
            ))}
        </Nav>
        </BootstrapNavbar>
    );
}

export default Navbar;